import core from "@/helpers/client";
const productCostPromotionService = {  
    async headProductCostPromotionAsync(params) {
      const result = await core.head(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/costpromotion`,
        params
      );
      return result;
    },
    async getProductCostPromotionListAsync(params) {
      const result = await core.fetch(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/costpromotion`,
        params
      )
      return result
    },  
    async SearchProductSkuIncludeProductPriceAsync(model) {
      const result = await core.create(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/costpromotion/searchprice`,
        model
      )
      return result
    }, 
    async getProductCostPromotionBySkuCodeAsync(params) {
      const result = await core.fetch(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/costpromotion/skucode`,
        params
      );
      return result;
    },
    async getProductCostPromotionByCondition(params) {
      const result = await core.fetch(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/costpromotion/condition`,
        params
      )
      return result;
    },
    async createProductCostPromotionListAsync(model) {
      const result = await core.create(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/costpromotion`,
        model
      );
      return result;
    },
    async updateProductCostPromotionListAsync(model) {
      const result = await core.update(
        `${process.env.VUE_APP_BASE_URL_PRODUCT}api/v1/ProductPrices/costpromotion`,
        model
      );
      return result;
    },
  }
  export default productCostPromotionService